<script lang="ts">
  import Alwan from 'alwan';
  import 'alwan/dist/css/alwan.min.css';
  import {createEventDispatcher, onDestroy, onMount} from 'svelte';
  import {logError} from '../../utils/logs';
  import {colorPaletteStore} from '../new-preview-sidebar/Modules/PalleteSelection/PalleteSelection.svelte';
  // export let target: Element;
  export let colorDefault: string | null = null;
  export let enableOutlinePicker: boolean = true;
  export const changeColor = (color: string) => {
    if (colorPicker) {
      colorPicker.setColor(color);
    }
  };
  let picker: HTMLElement;
  let isOpen = false;
  const dispatch = createEventDispatcher();

  let colorPicker: Alwan;
  const getSwatches = () => {
    let swatches = [];
    if (window.brandKit) {
      swatches = [window.brandKit.color1, window.brandKit.color2].filter(item => item !== null);
    }
    return swatches;
  };
  const alwanColorPicker = (node: HTMLElement) => {
    if (!node) throw '[Alwan color picker] Node is not defined';
    const colors = $colorPaletteStore;
    colorPicker = new Alwan(node, {
      swatches: colors,
      format: 'hex'
      // swatches: getSwatches()
    });

    if (!colorPicker) {
      throw 'Problem instantiating color picker';
    }
    colorPicker.on('open', () => {
      dispatch('open');
    });

    colorPicker.on('close', () => {
      dispatch('close');
    });

    colorPicker.on('change', (color, el) => {
      dispatch('change-color', {color: color.rgb, el});
    });

    colorPicker.on('color', (color, el) => {
      dispatch('update-color', {color: color.rgb, el});
    });
  };

  let eyeDropAvailable = typeof window !== 'undefined' && 'EyeDropper' in window;

  $: if (colorPicker && colorDefault) colorPicker.setColor(colorDefault);

  const eyeDrop = () => {
    if (!window.EyeDropper) return;
    const dropper = new window.EyeDropper();
    const abortController = new AbortController();
    dropper.open({signal: abortController.signal}).then((result: any) => {
      colorPicker.setColor(result.sRGBHex);
      dispatch('change-color', {color: result.sRGBHex});
    });
  };

  const handleClick = () => {
    if (isOpen) {
      colorPicker.close();
      isOpen = false;
    } else {
      colorPicker.open();
      isOpen = true;
    }
  };

  onMount(() => {
    if (!picker) return;

    try {
      alwanColorPicker(picker);
      if (!colorPicker || !colorDefault) return;
      colorPicker.setColor(colorDefault);
    } catch (err) {
      logError('Alwan color picker', err);
    }
  });

  onDestroy(() => {
    if (!colorPicker) return;
    colorPicker.destroy();
  });
</script>

<div class="relative flex h-full flex-col items-center overflow-hidden rounded-md">
  <button class="h-full w-full" on:click={handleClick}>
    <slot />
  </button>
  <div class="h-0 opacity-0">
    <div class="h-0 w-full" bind:this={picker}></div>
  </div>
</div>

{#if eyeDropAvailable && enableOutlinePicker}
  <button class="-ml-5 block cursor-pointer rounded-md" on:click={eyeDrop}>
    <span class="gg-color-picker" />
  </button>
{/if}

<style lang="postcss">
  .gg-color-picker {
    --ggs: 0.7;
  }
</style>
